module.exports = __webpack_public_path__ + "e4ca89208d97a0e0d556d99a0f92ee60.svg";